import { numberMoney, percentage } from 'Data/format.js'
import { MAX_DISCOUNT_PERCENTAGE_BASE } from 'Data/case-closer.js'

export function getMaxDiscount(max_discount) {
  switch (max_discount.type) {
    case 'percentage':
      let base = MAX_DISCOUNT_PERCENTAGE_BASE.find(
        item => item.id === max_discount.percentage_base
      )
      return `${percentage(max_discount.value)} off the ${base?.text ?? '-'}`
    case 'amount': {
      return numberMoney(max_discount.value)
    }
    default: {
      return ''
    }
  }
}
